import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';

import TextPlaceholder from 'components/consumer/TextPlaceholder';
import AlgoliaResultsCount from './AlgoliaResultsCount';

const ProductListingResultsCountWrapper = ({ children }) => (
  <span className="text-sm text-gray-light2 md:relative md:self-center">
    {children}
  </span>
);

const ProductListingResultsCount = ({
  loading = false,
  totalProductCount,
  variant,
}) => {
  if (variant === 'advanced-search') {
    return (
      <ProductListingResultsCountWrapper>
        <AlgoliaResultsCount suffix=" Results" />
      </ProductListingResultsCountWrapper>
    );
  }

  if (loading) {
    return <TextPlaceholder className="!w-[75px] !h-[15px]" />;
  }

  if (isNil(totalProductCount)) {
    return null;
  }

  return (
    <ProductListingResultsCountWrapper>
      {`${totalProductCount} Results`}
    </ProductListingResultsCountWrapper>
  );
};

ProductListingResultsCount.propTypes = {
  loading: PropTypes.bool,
  totalProductCount: PropTypes.number,
};

export default ProductListingResultsCount;
